import env from "~/env"

export const publisherIDAPI = new APIClient(env.publisherIDAPIBaseURL)
